<template>
    <div>
        <ContentHeader path-set-type="append" :gameplan-nav="false" />
        <div class="content-wrapper" v-loading="loading">
            <el-row>
                <div class="mask" v-if="isMask"></div>
                <div class="step" v-if=" queryCondition == '03'">
                    <el-steps :active="active" finish-status="success"  align-center>
                    <el-step  v-for="item in stepList" :key="item.index" :title="item.title">
                        <span v-if="item.name" slot="description" style="color: #cd1231;">({{ item.name }})</span>
                    </el-step>
                    </el-steps>
                </div>
                <div class="title">
                    <i @click="collClick('orderShow4')" style="cursor: pointer;" :class="[orderShow4 ? 'el-icon-caret-bottom' : 'el-icon-caret-right']"></i>
                    <span @click="collClick('orderShow4')" style="cursor: pointer;">活动主题信息</span>
                </div>
                <div class="card-box" v-show="orderShow4">
                    <div class="card is-hover-shadow" >
                    <div class="left">
                        <div class="left-top">
                            <div class="left">
                                <div class="top-name">{{themeBasic.themeName}}</div>
                                <div class="top-sign">{{getBluename(themeBasic.orgLevel)}}</div>
                            </div>
                            <div class="right">
                                    <span>{{getTime(themeBasic.themeStartTime)}}</span>
                                    <span style="margin:0px 10px;">至</span>
                                    <span>{{getTime(themeBasic.themeEndTime)}}</span>
                                </div>
                        </div>
                        <div class="pr-item-flex" v-if="themeDetailInfo.gpPrDTOList">
                          <div style="margin-right:50px;margin-top:12px;"><span class="font-weight-bold">PR信息：</span>{{prInfo}}</div>
                          <div style="margin-top:12px;"><span class="font-weight-bold">品牌信息：</span>{{brandInfo}}</div>
                        </div>
                        <div class="left-third">
                            <div class="left-third-left">
                                <span>活动执行数据收集模板</span>
                                <span @click="viewChangepop()" style="color: #409EFF;margin-left: 20px;cursor: pointer;">配置详情</span>
                            </div>
                            <div class="left-third-right">
                                <span class="text">活动执行手册</span>
                                <span  class="text" style="color: #409EFF;margin-left: 20px;cursor: pointer;">
                                    <span @click="viewPdf()" v-if="themeBasic.manualFileName && themeBasic.manualFileUri">{{ themeBasic.manualFileName }}</span>
                                    <span v-else>暂无附件</span>
                                </span>
                            </div>
                        </div>
                        <!-- <div class="left-fouth" v-if="themeBasic.skuDTOList" >
                            <div class="left-fouth-left">
                                <span>活动SKU：</span>
                            </div>
                            <div class="left-fouth-right">
                                <span>{{getSKU(themeBasic.skuDTOList,'、')}}</span>
                            </div>
                        </div> -->
                    </div>
                </div>
                </div>
                <div class="title" style="margin-top: 20px;">
                    <i @click="collClick('orderShow1')" style="cursor: pointer;" :class="[orderShow1 ? 'el-icon-caret-bottom' : 'el-icon-caret-right']"></i>
                    <span @click="collClick('orderShow1')" style="cursor: pointer;">活动配置信息</span>
                </div>
                <div class="card-box2 is-hover-shadow" v-show="orderShow1">
                    <div class="form">
                        <div class="item">
                            <div class="item-left">活动渠道</div>
                            <div class="item-right">
                                <span>{{themeChannelName}}</span>
                            </div>
                        </div>
                        <div class="item">
                            <div class="item-left">活动形式</div>
                            <div class="item-right">{{ themeStyleName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-left">活动级别</div>
                            <div class="item-right" v-if="themeLevelName">{{themeLevelName}}</div>
                            <div class="item-right" v-else>暂无</div>
                        </div>
                        <div class="item">
                            <div class="item-left">活动时间</div>
                            <div class="item-right" style="display: flex;justify-content: space-between;">
                                <div style="width:80%">
                                    <span>{{getTime(themeBasic.themeStartTime)}}</span>
                                    <span style="margin:0px 10px;">至</span>
                                    <span>{{getTime(themeBasic.themeEndTime)}}</span>
                                </div>
                                <div  @click="collClick('orderShow3')" style="flex:1;color:#409EFF;text-align:left;cursor: pointer;">
                                    <span v-if="!orderShow3">查看更多</span>
                                    <span v-else>收起</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form" style="display:block" v-show="orderShow3">
                        <div class="item-sign">
                            <div class="sign">
                                <div class="sign-left">场勘</div>
                                <div class="sign-right">
                                    <i v-if="checkCK" class="el-icon-success color-green"></i>
                                    <i v-else class="el-icon-error color-red "></i>
                                </div>
                            </div>
                            <div class="sign">
                                <div class="sign-left">搭建</div>
                                <div class="sign-right">
                                    <i v-if="checkDJ" class="el-icon-success color-green"></i>
                                    <i v-else class="el-icon-error color-red"></i>
                                </div>
                            </div>
                            <div class="sign">
                                <div class="sign-left">临促</div>
                                <div class="sign-right">
                                    <i v-if="checkSPR" class="el-icon-success color-green"></i>
                                    <i v-else class="el-icon-error color-red"></i>
                                </div>
                            </div>
                            <div class="sign">
                                <div class="sign-left">转场</div>
                                <div class="sign-right">
                                    <i v-if="needTransitions == 1" class="el-icon-success color-green"></i>
                                    <i v-else class="el-icon-error color-red"></i>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="item" style="width:100%" v-if="getDecorates('showDecorates')">
                            <div class="item-left">搭建点位</div>
                            <div class="item-right" >
                                <span v-if="getDecorates('showDecorates')">{{getDecorates('showDecorates')}}</span>
                            </div>
                        </div>
                        <div class="item" style="width:100%" v-if="getDecorates('showExecDecorates')">
                            <div class="item-left">执行点位</div>
                            <div class="item-right" >
                                <span>{{getDecorates('showExecDecorates')}}</span>
                            </div>
                        </div> -->
                        <div class="item" style="width:100%" v-if="getDecorates('all')">
                            <div class="item-left">点位照片</div>
                            <div class="item-right" >
                                <span>{{getDecorates('all')}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="form" v-show="orderShow3">
                        <div class="item">
                            <div class="item-left">单场投入预算</div>
                            <div class="item-right" v-if="investUnit">{{formatPrice(investUnit)}}</div>
                            <div class="item-right" v-else>暂无</div>
                        </div>
                        <div class="item" v-if="needTransitions == 1">
                            <div class="item-left">道具数量</div>
                            <div class="item-right">{{formatPrice(itemQuantity)}}</div>
                        </div>
                        <div class="item" v-else>
                            <div class="item-left">
                                <span v-if="pocRelateType == '1'">每售点执行天数</span>
                                <span v-if ="pocRelateType == '2'">每街区执行天数</span>
                                <span v-if ="pocRelateType == '0'">每活动地点执行天数</span>
                            </div>
                            <div class="item-right">
                                <span>{{formatPrice(perExecDays)}}</span>
                                <span style="margin:0px 0px;">天</span>
                            </div>
                        </div>
                        <div class="item"  v-if="themeDetail.needSpr == '1'">
                            <div class="item-left">临促人员人数限制</div>
                            <div class="item-right" v-if="themeDetail.pgQtyLimit">{{ formatPrice(themeDetail.pgQtyLimit) }}</div>
                            <div class="item-right" v-else>暂无</div>
                        </div>
                        <div class="item"  v-if="themeDetail.needSpr == '1'">
                            <div class="item-left">打卡/执行信息上传方式</div>
                            <div class="item-right" v-if="themeDetail.needPerformance == '1'">督导统一上传</div>
                            <div class="item-right" v-else>临促人员自行上传</div>
                        </div>
                        <div class="item" style="width:100%">
                            <div class="item-left">活动SKU</div>
                            <div class="item-right" >
                                <!-- <span>{{getSKU(themeDetail.skuDTOList,'、')}}</span> -->
                                <span v-if=" themeDetail.skuDTOList && themeDetail.skuDTOList.length > 0">
                                    <el-tag
                                        style=" margin:0 10px 8px 0px;cursor: pointer;"
                                        v-for="tag in  themeDetail.skuDTOList"
                                        :key="tag.skuCode"
                                        type="info">
                                        {{tag.skuName}}
                                    </el-tag>
                                </span>
                                <span v-else>暂无数据</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="title" style="margin-top: 20px;">
                    <i @click="collClick('orderShow2')" style="cursor: pointer;" :class="[orderShow2 ? 'el-icon-caret-bottom' : 'el-icon-caret-right']"></i>
                    <span @click="collClick('orderShow2')" style="cursor: pointer;">提报要求</span>
                </div>
                <div class="card-box3 is-hover-shadow"  v-show="orderShow2">
                    <div class="form">
                        <div class="item">
                            <div class="item-left">提报售点要求</div>
                            <div class="item-right">
                                <span>{{saleTypename}}</span>
                            </div>
                        </div>
                        <div class="item" v-if="pocRelateType == '2'">
                            <div class="item-left">最少关联售点设置</div>
                            <div class="item-right">{{formatPrice(pocCountMin)}}</div>
                        </div>
                        <div class="item">
                            <div class="item-left">额度信息</div>
                            <div class="item-right">
                                <div v-for="item in themeDetail.detailDTOList" :key="item.regionCode">
                                    <div v-if="item.totalCountQty > 0">
                                        <span style="margin:0px 5px 0px 0px;">{{getRegionName(item)}}</span>
                                        <span>{{formatPrice(item.totalCountQty)}}{{ showText }}</span>
                                        <span>（已通过：</span>
                                        <span>{{formatPrice(item.passedCountQty)}}{{ showText }}</span>
                                        <span style="margin:0px 5px;">/</span>
                                        <span>审核中：</span>
                                        <span>{{formatPrice(item.approvalCountQty)}}{{ showText }}</span>
                                        <span style="margin:0px 5px;">/</span>
                                        <span>未提报：</span>
                                        <span>{{formatPrice(item.notReportCountQty)}}{{ showText }}</span>
                                        <span>）</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="cross" style="margin-top:-20px" v-if="!loading">
                    <ReportPop
                        :dataForm ='themeDetailInfo'
                        :queryCondition="queryCondition"
                        :themeBasic = 'themeBasic'
                        :igniteOptions="igniteOptions"
                        :regionCode="regionCode"
                        :routerType="routerType"
                        @clickStorename = 'clickStorename'
                        @activityChanged="activityChanged"
                        >
                    </ReportPop>
                </div>
                <div v-if="showChangepop" class="changePop">
                    <configBuChangePop
                    @closeChangepop="closeChangepop"
                    :themeId="themeBasic.themeId"
                    ></configBuChangePop>
                </div>
            </el-row>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { commonUtils } from '@/utils/common'
    import gameplanApi from '../../api/gameplan'
    import ContentHeader from '@/components/content-header'
    import ReportPop from './components/activity-report-pop.vue'
    import configBuChangePop from './components/config-buChange-pop.vue'
    export default {
      name: 'activity-report-detail',
      components: {
        ContentHeader,
        ReportPop,
        configBuChangePop
      },
      data () {
        return {
            themeBasic: {},
            detailList: {},
            applyEmpName: '',
            cityName:'',
            buCode: '',
            regionCode: '',
            channelList:[],
            fullConfig:[],
            themeChannelCodes:[],
            activityId: "",
            typeStatus: '',
            queryCondition: '',
            orderShow1: true,
            orderShow2: true,
            orderShow3:false,
            orderShow4:true,
            loading: true,
            igniteOptions: {},
            checkCK: false, // 场勘
            checkDJ: false, // 搭建
            checkSPR: false, // SPR
            themeDecorates: '', //点位信息
            perExecDays:'',
            pocRelateType:'',
            pocCountMin:'',
            itemQuantity:'',
            needTransitions:'',
            saleTypename:'',
            routerType:'',
            investUnit: '', // 单场投入预算
            themeChannelName:'',
            themeStyleName:'',
            themeLevelName:'',
            themeDetail:'',
            themeDetailInfo: {},
            themeDetailId:'',
            showChangepop: false,
            isMask:false,
            congfigDetail:null,// 配置信息
            isRegion: false,
            stepList:[],
            active: 0,
            prInfo:'',
            brandInfo:''
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
        showText () {
            if(this.needTransitions == 1) {
                return '场'
            } else {
                if (this.pocRelateType == '1') {
                    return '售点'
                } else if (this.pocRelateType == '0') {
                    return '地点'
                } else if (this.pocRelateType == '2') {
                    return '街区'
                } else {
                    return ''
                }
            }
        }
      },
      watch: {},
      created () {
        this.activityId = this.$route.query.activityId
        this.themeDetailId  = this.$route.query.themeDetailId
        this.typeStatus = this.$route.query.typeStatus
        this.regionCode = this.userInfo.regionCode
        this.routerType = this.$route.query.routerType
        // 待审批 200-bu ,300-hq
        if (this.typeStatus == '200' || this.typeStatus == '300' ) {
            this.queryCondition = '06'
        }
        // 执行中
        if (this.typeStatus == '400') {
            this.queryCondition = '02'
        }
        // 已完成
        if (this.typeStatus == '500') {
            this.queryCondition = '09'
        }
        // 已退回
        if (this.typeStatus == '1000') {
            this.queryCondition = '03'
        }
        // if (this.typeStatus == '03') {
        //     this.queryCondition = '03'
        // }
        // if (this.typeStatus == '02') {
        //     this.queryCondition = '02'
        // }
        // if (this.typeStatus == '01') {
        //     this.queryCondition = '01'
        // }
        // if (this.typeStatus == '09') {
        //     this.queryCondition = '09'
        // }
        this.init()
      },
      mounted () {},
      updated () {
      },
      methods: {
        init () {
            this.getDetailinfo()
            if(this.userInfo.employeeLevel === 50 || this.userInfo.employeeLevel === 45){
                this.isRegion = true
            }
        },
        // 金额千分
        formatPrice(price) {
            return String(price).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        lockScroll() {
            let widthBar = 17, root = document.documentElement;
            if (typeof window.innerWidth == 'number') {
                widthBar = window.innerWidth - root.clientWidth;
            }
            root.style.overflow = 'hidden';
            root.style.borderRight = widthBar + 'px solid transparent';
        },
        unlockScroll() {
            let root = document.documentElement;
            root.style.overflow = '';
            root.style.borderRight = '';
        },
        viewPdf () {
            if (this.themeBasic.manualFileUri) {
                window.open(commonUtils.getImageUrl(this.themeBasic.manualFileUri))
            } else {
                console.log('manualFileUri为空');
            }
        },
        viewChangepop () {
            this.isMask = true
            this.showChangepop = true
            this.lockScroll()
        },
        closeChangepop () {
            this.isMask = false
            this.showChangepop = false
            this.unlockScroll()
        },
        getSKU (arr,sign) {
            if (arr && arr.length > 0) {
                let name = arr.map((item)=>{
                return item.skuName
                }).join(sign)
                return name
            } else {
                return '暂无数据'
            }
        },
        async activityChanged () {
            let params = {
                'activityId':this.activityId,
                'themeDetailId':this.themeDetailId
            }
            let {data} = await gameplanApi.getGamepalnDetail(params)
            if (data.resultCode == '0') {
                this.themeBasic = data.resultData.themeDetailInfo.themeBasic
                this.themeDetail = data.resultData.themeDetailInfo.themeDetail
            }
        },
          // 获取check值
          getCheckvalue () {
            let data = this.themeDetail
            // spr
            if (data.needSpr == 1) {
                this.checkSPR = true
            } else {
                this.checkSPR = false
            }
            // 场勘
            if (data.needVerify == 1) {
                this.checkCK = true
            } else {
                this.checkCK = false
            }
            // 搭建
            if (data.needConstruct == 1) {
                this.checkDJ = true
            } else {
                this.checkDJ = false
            }
        },
        // 获取点位信息
        getDecorates (type) {
            let data = this.themeDetail.themeDecorates
            let showDecorates = []
            let showExecDecorates = []
            if (data && this.congfigDetail) {
                if (this.congfigDetail.showDecorates) {
                    for (let item1 of this.congfigDetail.showDecorates) {
                        for (let item2 of data) {
                            if (item2.decorateCode == item1.decorateCode) {
                                showDecorates.push(item2)
                            }
                        }
                    }
                }
                if (this.congfigDetail.showExecDecorates) {
                    for (let item1 of this.congfigDetail.showExecDecorates) {
                        for (let item2 of data) {
                            if (item2.decorateCode == item1.decorateCode) {
                                showExecDecorates.push(item2)
                            }
                        }
                    }
                }

                if (type == 'showDecorates') {
                    if (showDecorates.length > 0) {
                        let name = showDecorates.map((item)=>{
                            return item.decorateName
                        }).join('、')
                        return name
                    } else {
                        return false
                    }
                } else if (type == 'showExecDecorates') {
                    if (showExecDecorates.length > 0) {
                        let name = showExecDecorates.map((item)=>{
                            return item.decorateName
                        }).join('、')
                        return name
                    } else {
                        return false
                    }
                } else if (type == 'all') {
                    if (data.length > 0) {
                        let name = data.map((item)=>{
                            return item.decorateName
                        }).join('、')
                        return name
                    } else {
                        return false
                    }
                } else {
                    return
                }
            } else {
                return ''
            }
        },
        getpocRelateType () {
            this.pocRelateType = this.themeDetail.pocRelateType
            this.pocCountMin = this.themeDetail.pocCountMin
            this.itemQuantity = this.themeDetail.itemQuantity
            this.needTransitions = this.themeDetail.needTransitions
            this.perExecDays = this.themeDetail.perExecDays
            this.investUnit = this.themeDetail.investUnit
            this.themeChannelName = this.themeDetail.themeChannelName.split('|')[0]
            this.themeStyleName = this.themeDetail.themeStyleName
            this.themeLevelName = this.themeDetail.themeLevelName
            if (this.pocRelateType == 0) {
                return this.saleTypename = '无售点'
            }else if (this.pocRelateType == 1) {
                return this.saleTypename = '单售点'
            } else if (this.pocRelateType == 2) {
                return this.saleTypename = '多售点'
            } else {
                return this.saleTypename = 'error'
            }
        },
        getRegionName (item) {
            if (item) {
                if (this.isRegion) {
                    return item.regionName.split('|')[0] + ":"
                } else {
                    return item.buName.split('|')[0] + ":"
                }
            }else {
                return '无'
            }
        },
        getBluename (name) {
            if (name == 'region') {
                return 'Region'
            } else if (name == 'bu') {
                return 'BU'
            } else if (name == 'hq') {
                return 'HQ'
            } else {
                return 'error'
            }
        },
        getChannel(a,b){
            let themeChannels = a || []
            let arr = themeChannels.map((item) => {
                    return item.themeChannelEnName
                }).join(b)
            return arr
        },
        getTime (timestamp) {
        if (timestamp === 0 || timestamp == null) {
            return ''
        } else {
            var date = new Date(parseInt(timestamp)) // 时间戳为13位的话需要parseInt下
            const Y = date.getFullYear() + '-'
            const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
            const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
            // const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
            // const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
            // const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
            return Y + M + D
        }
        },
        getShowDetail(){
          let brandInfo = []
          let prInfo = []
          const gpPrDTOList = this.themeDetailInfo.gpPrDTOList
          if(gpPrDTOList){
              gpPrDTOList.forEach(item=>{
              let data = ''
              if(item.brandName&&item.subBrandName)  data = item.brandName+'-'+item.subBrandName
              else data = item.brandName||item.subBrandName
              if(brandInfo.indexOf(data)===-1) {
                  brandInfo.push(data)
              }
              prInfo.push(item.prNumber+'-'+item.prName)
              })
              this.brandInfo = brandInfo.join('、')
              this.prInfo = prInfo.join('、')
          }
        },
        async getDetailinfo () {
            let params = {
                'activityId':this.activityId,
                'themeDetailId':this.themeDetailId
            }
            let {data} = await gameplanApi.getGamepalnDetail(params)
            if (data.resultCode == '0') {
                this.themeDetailInfo = data.resultData.themeDetailInfo
                this.themeBasic = data.resultData.themeDetailInfo.themeBasic
                this.themeDetail = data.resultData.themeDetailInfo.themeDetail
                this.getCheckvalue()
                this.getpocRelateType()
                this.getConfigfull()
                this.getShowDetail()
                this.loading = false
                let orgLevel = this.themeBasic.orgLevel
                let rejectClientLevel =  this.themeDetailInfo.gpActivityInfoVOList[0].gpActivityInfoDTO.rejectClientLevel
                // let rejectClientName =  this.themeDetailInfo.gpActivityInfoVOList[0].gpActivityInfoDTO.rejectClientName
                let rejectClientName = ''
                if (orgLevel == 'hq') {
                    if  (rejectClientLevel == 'bu' ){
                        this.active = 2
                        this.stepList = [
                            {name:'',index:0,title:'提交'},
                            {name:rejectClientName,index:1,title:'BU已审批'},
                            {name:'',index:3,title:'已退回'},
                        ]
                    } else if  (rejectClientLevel == 'hq' ){
                        this.active = 3
                        this.stepList = [
                            {name:'',index:0,title:'提交'},
                            {name:'',index:1,title:'BU已审批'},
                            {name:rejectClientName,index:2,title:'HQ已审批'},
                            {name:'',index:3,title:'已退回'},
                        ]
                    }
                } else if (orgLevel == 'bu') {
                    this.active = 2
                    this.stepList = [
                        {name:'',index:0,title:'提交'},
                        {name:rejectClientName,index:1,title:'BU已审批'},
                        {name:'',index:2,title:'已退回'},
                    ]
                } else {
                    return
                }
            } else {
                this.loading = false
            }
        },
        // 获取配置信息
        async getConfigfull () {
            let {data} = await gameplanApi.getGameplanConfigFull()
            if (data.resultCode == '0') {
                let fullConfig = data.resultData.fullConfig
                for (let item1 of fullConfig) {
                    if (item1.themeChannelCode == this.themeDetail.themeChannelCode) {
                        for (let item2 of item1.themeStyles) {
                            if (item2.themeStyleCode == this.themeDetail.themeStyleCode) {
                                if (this.themeDetail.themeLevelCode && item2.themeLevels.length > 0) {
                                    for (let item3 of item2.themeLevels) {
                                        if (item3.themeLevelCode == this.themeDetail.themeLevelCode) {
                                            this.congfigDetail = item3.themeConfig
                                        }
                                    }
                                } else {
                                    this.congfigDetail = item2.themeConfig
                                }
                            }
                        }
                    }
                }
            }
        },
        clickStorename (row) {
            this.$router.push({path:'/gameplan/activityPhoto-salePlace-detail',query:{activityId:row.activityId}})
        },
        // 订单明细显示隐藏
        collClick (name) {
            if (name == 'orderShow1') {
                this.orderShow1 = !this.orderShow1
            } else if (name == 'orderShow2') {
                this.orderShow2 = !this.orderShow2
            } else if (name == 'orderShow3') {
                this.orderShow3 = !this.orderShow3
            } else if (name == 'orderShow4') {
                this.orderShow4 = !this.orderShow4
            }
        },
    }
}
</script>
<style lang="scss" scoped>
    .is-hover-shadow:hover {
        box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
    }
    .content-wrapper {
        min-height: calc(100vh - 320px) !important;
        font-family: SourceHanSansSC-regular;
        .step {
            padding: 10px 10px 10px 20px;
            background-color: #FFFFFF;
            color: #101010;
            border-radius: 10px;
            margin-bottom: 20px;
            ::v-deep.el-step__title {
                color:#666666;
            }
            ::v-deep.el-step__title.is-success {
                color: #101010;
            }
            ::v-deep.el-step__head.is-success .el-step__line-inner {
                background-color: #101010;
            }
            ::v-deep.el-step__head.is-success {
                color: #CD1231;
                border-color: #CD1231;
            }
            ::v-deep.el-step__title.is-process {
                // font-weight: 700;
                // color: #303133;
                font-weight: 500;
                color: #666666;
            }
            ::v-deep.el-step__head.is-process {
                color: #CD1231;
                border-color: #CD1231;
            }
        }
        .title {
            line-height: 40px;
            text-align: left;
            color: #101010;
            font-size: 18px;
            font-weight: 600;
        }
        .card-box {
            .card {
                display: flex;
                justify-content: flex-start;
                padding:10px  20px;
                background-color: #FFFFFF ;
                border-radius: 10px;
                font-size: 14px;
                .left {
                    flex: 1;
                    text-align: left;
                    color: #101010;
                    .left-top {
                        display: flex;
                        .left {
                            width: 70%;
                            font-size: 18px;
                            display: flex;
                            .top-name {
                                // padding: 2px 0px;
                                font-weight: 600;
                                word-wrap: break-word;
                                word-break: normal;
                                word-break: break-all;
                            }
                            .top-sign {
                                // padding: 2px 8px;
                                color: #FFFFFF;
                                background-color: #40A5EE;
                                margin-left: 10px;
                                // border-radius: 3px;
                                // height: 20px;
                                padding: 0px 8px;
                                line-height: 18px;
                                height: 18px;
                                font-size: 14px;
                                margin-top: 1px;
                                font-weight: 600;
                            }
                        }
                        .right {
                            flex: 1;
                            line-height: 20px;
                            font-size: 14px;
                            text-align: right;
                            word-wrap: break-word;
                            word-break: normal;
                            word-break: break-all;
                        }
                    }
                    .fouth {
                        font-size: 14px;
                        line-height: 20px;
                        color: #101010 ;
                        margin-top: 15px;
                        display: flex;
                        .fouth-left {
                            display: flex;
                            .first-center {
                                height: 15px;
                                line-height: 15px;
                                padding: 3px 10px;
                                text-align: center;
                                border-radius: 4px;
                                border: 1px solid #539EFE;
                                background-color: #FFFFFF;
                                color: #539EFE;
                                margin-left: 20px;
                                margin-top: -1px;
                            }
                        }
                        .fouth-right {
                            // color: #999999 ;
                            flex: 1;
                            margin-left: 50px;

                        }
                    }
                    .left-third {
                        font-size: 14px;
                        height: 20px;
                        line-height: 20px;
                        margin-top: 12px;
                        display: flex;
                        justify-content: flex-start;
                        .left-third-left {
                            display: flex;
                            justify-content: flex-start;
                            margin-right: 80px;
                        }
                        .left-third-right {
                            display: flex;
                            justify-content: flex-start;
                            .img {
                            width: 20px;
                            margin-right: 3px;
                            }
                            // .text {
                            //     margin: 0px 3px 0px 3px ;
                            //     // color: #539EFE;
                            // }
                        }
                    }
                    .left-fouth {
                        display: flex;
                        font-size: 14px;
                        line-height: 20px;
                        margin-top: 12px;
                        .left-fouth-left {
                            width: 70px;
                        }
                        .left-fouth-right {
                            flex: 1;
                        }
                    }
                }
                .right {
                    text-align: right;
                    .right-top {
                        line-height: 27px;
                        color: #999999;
                        font-size: 16px;
                    }
                }
            }
        }
        .card-box2 {
            padding: 10px 20px;
            background-color: #FFFFFF;
            color: #101010;
            border-radius: 10px;
            .form{
                display: flex;
                flex-wrap: wrap;
                padding-left: 8px;
                .item {
                    width: 50%;
                    line-height: 33px;
                    font-size: 14px;
                    color: #101010;
                    display: flex;
                    text-align: left;
                    .item-left {
                        text-align: right;
                        width: 148px;
                        font-weight: 600;
                        margin-right: 40px;
                    }
                    .item-right {
                        flex: 1;
                        word-wrap: break-word;
                        word-break: normal;
                        word-break: break-all;
                    }
                }
                .item-sign {
                    line-height: 33px;
                    font-size: 14px;
                    color: #101010;
                    display: flex;
                    text-align: left;
                    padding-left: 104px;
                    .sign {
                        display: flex;
                        margin: 0px 15px;
                        .sign-left {
                            margin-right: 5px;
                            font-weight: normal;
                            line-height: 33px;
                        }
                        .sign-right {
                            margin-top: 3px;
                            .color-green {
                                color: rgb(42, 219, 33);
                                font-size: 18px;
                            }
                            .color-red {
                                color: rgb(219, 93, 33);
                                font-size: 18px;
                            }
                        }
                    }
                }
            }
        }
        .card-box3 {
            padding: 10px 20px;
            background-color: #FFFFFF;
            color: #101010;
            border-radius: 10px;
            .form{
                padding-left: 8px;
                .item {
                    line-height: 33px;
                    font-size: 14px;
                    color: #101010;
                    display: flex;
                    text-align: left;
                    .item-left {
                        text-align: right;
                        width: 127px;
                        font-weight: 600;
                        margin-right: 40px;
                    }
                    .item-right {
                        flex: 1;
                        word-wrap: break-word;
                        word-break: normal;
                        word-break: break-all;
                    }
                }
            }
        }
        .changePop {
            position: fixed;
            top: 5vh;
            left: calc((100vw - 800px)/2);
            width: 800px;
            padding: 20px;
            background-color: #FFFFFF;
            border-radius: 10px;
            z-index: 3;
            max-height: 90vh;
        }
        .mask{
            position: fixed;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: rgba(0,0,0,.7) ;
            z-index: 3;
        }
    }
  .pr-item-flex{
    display:flex;
    flex-wrap:wrap;
  }
</style>
